var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#727272;}\r\n\t.st1{fill:#737373;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.5,26.9c-5-6.6-12.9-12.4-20.6-13.7c0,0-3.2-0.6-6.4,0.7c-7.2,3-13,6.4-18.1,13c-5,6.6,2.7,8.2,2.7,8.2v-1.5 c0,0,6.2-2.7,19.8-2.7c13.5,0,19.8,2.7,19.8,2.7v1.5l0.1,0C49.7,35.1,57.5,33.5,52.5,26.9 M32.7,23.7l-2.3,1.4 c-0.2,0.4-0.4,0.7-0.6,0.7c-0.2,0-0.4-0.3-0.6-0.6l-2.5-1.5v-3.8l2.5,1.3v0.1c0.2-0.4,0.3-0.6,0.6-0.6c0.2,0,0.3,0.2,0.5,0.5 l2.5-1.3V23.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.4,34.5c-7.5-0.1-19.3,1.8-19.3,1.8s9.3,8.2,19.8,8.2c10.4,0,19.8-8.2,19.8-8.2S36.9,34.5,29.4,34.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrew);
export default __webpack_public_path__ + "static/media/crew.37115bdf0cd2a7b5f50232a73cbd6a76.svg";
export { ForwardRef as ReactComponent };